const nsp = 'emailer/';

const EMAILER_TYPES = {
  SET_LOADER_STATUS: `${nsp}SET_LOADER_STATUS`,
  SET_EMAILER_DATA: `${nsp}SET_EMAILER_DATA`,
};

export default EMAILER_TYPES;
